module.exports = __webpack_public_path__ + "static/media/15.6ee117e1.webp";